/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description config
 */

import Environment from 'utils/environment';
import integration from './config.integration';
import production from './config.production';

const config = Environment.isIntegration() ? integration : production;
export default config;
